import { Route, Routes } from "react-router-dom";
import SmallwareOrderingRoute from './private-route'
import Home from "../components/home";
import CreatePO from "../components/purchase-order/create-po";
import PODetails from "../components/purchase-order/po-details";
import EditPO from "../components/purchase-order/edit-po";
import CreateGRN from "../components/smallware-po-grn/create-grn";
import GRNDetails from "../components/smallware-po-grn/grn-details";
import EditGRNDetails from "../components/smallware-po-grn/edit-grn-details";

const SmallwareOrderingRoutes = () => {
  return (
    <Routes>
      <Route exact path="/" element={<SmallwareOrderingRoute />}>
        <Route exact path="/" element={<Home />} />        
        <Route
          exact
          path="purchase-order/create/:budgetId"
          element={<CreatePO />}
        />        
        <Route exact path="purchase-order/:id" element={<PODetails />} />
        <Route exact path="purchase-order/edit/:id" element={<EditPO />} />        
        <Route exact path="grn/:id" element={<GRNDetails />} />
        <Route exact path="grn/edit/:id" element={<EditGRNDetails />} />
        <Route exact path="grn/create/:poId" element={<CreateGRN />} />
      </Route>
    </Routes>
  );
};

export default SmallwareOrderingRoutes;
